const CurrentLocale = {
    language: 'ru',
    variants: [
        {text: "EN", value: "en"},
        {text: "RU", value: "ru"},
    ],
}
export default CurrentLocale;